const state = {
    url: '',
    urlMap: {}
};
const mutations = {
    setSimulationUrl: (state:any, url:string) => {
        console.log('setSimulationUrl', url);
        state.url = url;
    },
    setSimulationUrlMap: (state:any, map:Object) => {
        console.log('setSimulationUrlMap', map);
        let temp = {};
        for (let key in map) {
            temp[key] = map[key];
        }
        state.urlMap = temp;
    },
    addSimulationUrlToMap: (state:any, map:Object) => {
        console.log('addSimulationUrlToMap', map);
        Object.assign(state.urlMap, map);
    }
};

export default {
    namespaced: true, // 这个是命名空间，用来区分不同的模块，我是根据文件的名字来区分
    state,
    mutations
};
